<template>
	<section
		v-if="data && (loadingPostsStatus === 'success' || loadingPostsStatus === 'loading') && postsToDisplay.length"
		class="margin-module"
	>
		<div class="container">
			<div v-if="data.module_title || data.title" :class="{ 'related-title': related }" class="margin-bottom-sm">
				<h2 :class="titleClass">{{ data.module_title || data.title }}</h2>
			</div>

			<div v-if="postsToDisplay && postsToDisplay.length" class="events-list">
				<EventBlock :data="eventInfo" v-for="eventInfo in postsToDisplay" :key="eventInfo.id" />
			</div>
		</div>

		<div v-if="archiveButton" class="more-button margin-top-lg text-center">
			<Button :theme="btnTheme" :url="eventArchiveLink" icon="arrowRight">All events</Button>
		</div>
	</section>
</template>

<script>
import EventBlock from '@/components/parts/EventBlock'
import Button from '@/components/elements/Button'

import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'events-archive-module',
	props: {
		data: {
			type: Object,
			required: false,
		},
		related: {
			type: Boolean,
			default: false,
		},
		archiveButton: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			postType: 'events',
			postItems: [],
			loadingPostsStatus: 'loading',
			maxPosts: 0,
			isLoadingMore: false,
			eventArchiveLink: WPVUE.pages && WPVUE.pages && WPVUE.pages.events ? WPVUE.pages.events.link : '/events',
		}
	},
	components: {
		EventBlock,
		Button,
	},
	mounted() {
		const VM = this

		if (!VM.data) return false
		VM.loadPosts()
	},
	computed: {
		titleClass() {
			if (this.related) {
				return 'module-title related font-size--26 text-center'
			} else {
				return 'module-title font-size--26 text-center'
			}
		},
		btnTheme() {
			if (this.currentPage.type === 'events') {
				return this.currentPage.acf && this.currentPage.acf.category !== 'default'
					? this.currentPage.acf.category
					: 'dark'
			} else {
				return this.pageTheme && this.pageTheme !== 'default' ? this.pageTheme : 'dark'
			}
		},
		colorFilters() {
			return this.getOptions.events_month_filters && this.getOptions.events_month_filters.length
				? this.getOptions.events_month_filters
				: false
		},
		postsLimit() {
			return 3
		},
		...mapGetters(['currentPageID', 'getOptions', 'pageTheme', 'currentPage']),

		taxonomy() {
			return 'event_category'
		},
		includePosts() {
			return this.data.select_post || 0
		},

		loadOpt() {
			//event_datetime
			const VM = this
			if (!VM.data) return []
			let opt = {
				type: VM.postType || 'events',
				include: VM.includePosts,
				order: 'asc',
				orderby: 'order_date',
				exclude: VM.data.exclude || 0,
				limit: VM.data.limit || VM.postsLimit,
				category: VM.data.type || 0,
				extra_category: VM.data.category || 'any',
				//taxonomy : VM.taxonomy,
			}

			if (VM.data.meta) opt.meta = VM.data.meta
			if (VM.data.past_event) opt.past_event = true
			if (VM.data.all_events) opt.all_events = true
			if (VM.data.value) opt.value = VM.data.value
			if (VM.data.include) opt.include = VM.data.include

			return opt
		},
		exclude() {
			let exclude = 0
			if (this.currentPageID) {
				exclude = [this.currentPageID]
			}
			if (this.data.exclude) {
				exclude = [...exclude, ...this.data.exclude]
			}
			return exclude
		},
		postsToDisplay() {
			return this.postItems
		},
	},

	methods: {
		...mapActions(['getPost']),

		loadPosts(options) {
			let loadOpt = {}
			const VM = this

			if (!options) {
				loadOpt = { ...VM.loadOpt }
			} else {
				loadOpt = { ...options }
			}

			if (VM.data.meta) loadOpt.meta = VM.data.meta
			if (VM.data.value) loadOpt.value = VM.data.value

			VM.loadingPostsStatus = 'loading'

			//loadOpt.category

			return VM.getPost(loadOpt).then((res) => {
				if (res.data && res.data.posts && res.data.posts.length) {
					if (VM.includePosts) {
						VM.postItems.push(...mapOrder(res.data.posts, VM.includePosts, 'id'))
					} else {
						if (VM.isLoadingMore) {
							VM.postItems = [...VM.postItems, ...res.data.posts]
						} else {
							VM.maxPosts = res.data.posts_found
							VM.postItems = [...res.data.posts]
						}
					}
				}
				if (res.data && res.data.posts && !res.data.posts.length) {
					VM.postItems = []
				}
				VM.isLoadingMore = false
				VM.loadingPostsStatus = 'success'
				return VM.loadingPostsStatus
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-archive_event_block {
}
</style>
